module.exports = __webpack_public_path__ + "static/media/icon-report-sidebar-milestone.ab5d88d6.svg";